import { Loading, NoData } from './components/widgets'

import { useSelector } from 'react-redux'
import { isEmpty } from '../utils.js'
import { AuthorizationGate } from './components/Authorization.js'
import { FursuitVoting } from './components/voting'

export const FursuitVotingHome = () => {
  const { campaigns, fursuits, votes, votedUsers, deadline, deadlineMs, votingStart, votingStartMs } = useSelector(state => state.voting?.fursuit)
  const votingNotStarted = votingStart != null && votingStart > 0
  const fursuitVotingData = {
    campaigns,
    fursuits,
    votes,
    votedUsers,
    deadline,
    deadlineMs,
    votingStartMs,
    votingNotStarted
  }
  const { loading } = useSelector((state) => state.navigation)
  if ((isEmpty(fursuits) || isEmpty(campaigns)) && loading) {
    return <Loading />
  } else if (
    (isEmpty(fursuits) || isEmpty(campaigns)) && !loading
  ) {
    return <NoData />
  }
  return (
    <AuthorizationGate>
      <FursuitVoting fursuitVotingData={fursuitVotingData} />
    </AuthorizationGate>
  )
}
